export const EXTRA_EXTRA_SMALL_DRAWER_WIDTH = '351px'
export const EXTRA_SMALL_DRAWER_WIDTH = 'min(45%,550px)'
export const SMALL_DRAWER_WIDTH = 'min(55%,800px)'
export const MEDIUM_DRAWER_WIDTH = 'min(75%,1056px)'
export const LARGE_DRAWER_WIDTH = 'min(80%,1440px)'
